import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { VisibilityService } from 'src/app/services/visibility.service';
import { FormBuilder } from '@angular/forms';
import { UsersService } from 'src/app/services/users.service';
import { ResponseObjectAPI } from '../../../models/responseObjectAPI';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  visibilitieGroups: Array<any>;
  workflows: Array<any>;
  visibilityForm = this.fb.group({
    visibilityGroupId: ['']
  })
  @Input() showAddRequirement;
  @Input() showVisibilities;

  dataUser;

  @Input() header: string;
  // @Output() visibilityGroupSelected = new EventEmitter();
  @Output() dataSession = new EventEmitter();

  constructor(
    public fb:FormBuilder,
    public visibilityService: VisibilityService,
		public usersService: UsersService,
		
  ) {
    this.usersService.getDataUser().subscribe((data: ResponseObjectAPI) => {
      this.dataUser = data.result;
      this.dataSession.emit(this.dataUser);
    });
  }

  ngOnInit() {
    // this.visibilityService.getVisibility().subscribe(resp => {
    //   this.visibilitieGroups = resp['result'];

    //   let visibilityGroupId = this.visibilitieGroups[0].id;

    //   this.visibilityForm = this.fb.group({
    //     visibilityGroupId
    //   })

    //   this.visibilityGroupSelected.emit({visibilityGroupId});
		// });

    
  }



  // onChangeVisibilityGroup(event):void {
  //   // this.visibilitySelected = 5;
  //   this.visibilityGroupSelected.emit({visibilityGroupId: event.target.value});
  // }

}
